<!-- 商品发布 - 商品详情 -->
<template>
	<a-form-model ref="formRef" :model="formData" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" :disabled="isDetail">
		<!--富文本编辑器组件-->
		<a-form-model-item label="商品详情" prop="description">
			<Toolbar :editor="wangEditor.editor"  :defaultConfig="wangEditor.toolbarConfig" :mode="wangEditor.mode"/>
			<Editor style="height: 500px; overflow-y: hidden; border: 1px solid #ccc" v-model="formData.description" :defaultConfig="wangEditor.editorConfig" :mode="wangEditor.mode" @onCreated="wangEditorFinish"/>
		</a-form-model-item>
	</a-form-model>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { copyValueToTarget } from '@/utils'

export default {
	name: 'ProductDescriptionForm',
	components: {
		Editor,
		Toolbar
	},
	props: {
		propFormData: {
			type: Object,
			default: () => {}
		},
		activeName: {
			type: String,
			default: ''
		},
		isDetail: {
			type: Boolean,
			default: false // 是否作为详情组件
		}
	},
	data() {
		return {
			form: this.$form.createForm(this),
			wangEditor: {
				editor: null,
				toolbarConfig: { excludeKeys: ['group-video', 'fullScreen'] },
				editorConfig: {
					placeholder: '请输入内容...', 
					MENU_CONF:{
						uploadImage:{
							server: this.navigation.apiUploadFiles,
							fieldName: 'fileName',
							customInsert:(res, insertFn)=>{
								console.log(res.data);
								insertFn(this.navigation.url + res.data, "", "")
							}
						},
					},
				},
				mode: 'default', // 'default' or 'simple'
			},
			formData: {
				description: '' // 商品详情
			},
			// 表单规则
			rules: {
				description: [{ required: true, message: '请填写商品详情', trigger: 'change' }]
			}
		}
	},
	watch: {
		'formData.description': {
			handler: function(newValue) {
				// 富文本编辑器如果输入过再清空会有残留，需再重置一次
				if ('<p><br></p>' === newValue) {
					this.formData.description = ''
				}
			},
			deep: true,
			immediate: true
		},
		propFormData: {
			handler: function(data) {
				if (!data) return
				// fix：三个表单组件监听赋值必须使用 copyValueToTarget 使用 formData.value = data 会监听非常多次
				copyValueToTarget(this.formData, data)
			},
			// fix: 去掉深度监听只有对象引用发生改变的时候才执行,解决改一动多的问题
			immediate: true
		}
	},
	methods: {
		/** 表单校验 */
		async validate() {
			try {
				await this.$refs.formRef.validate()
				// 校验通过更新数据
				Object.assign(this.propFormData, this.formData)
			} catch (e) {
				this.$message.error('【商品详情】不完善，请填写相关信息')
				this.$emit('update:activeKey', 'description')
				throw e // 目的截断之后的校验
			}
		},
		//编辑器初始化
		wangEditorFinish(editor) {
			this.wangEditor.editor = Object.seal(editor)
		},
	}
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="less">
.qa-modal .ant-form{
  overflow-y:auto;
}
</style>
